module.exports = __webpack_public_path__ + "img/0020.7491c0aa.png";